import { Route as PublicRoute } from 'react-router-dom';

import { PATH_NAME } from '../pathNames';
import { AlertsResolved } from '../lazyLoaded';

const AlertsResolvedRoute = () => (
  <PublicRoute
    exact
    path={PATH_NAME.ALERTS_RESOLVED}
    component={(props: JSX.IntrinsicAttributes) => (
      <AlertsResolved {...props} />
    )}
  />
);
export default AlertsResolvedRoute;
